const REASONS = [
  {
    icon: 'ri-user-heart-line',
    title: 'Reliability You Can Count On',
    description: 'We show up, we follow through — every project, every time. No excuses, no delays. Your schedule matters as much as your build.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Fair & Transparent Pricing',
    description: 'Honest quotes upfront. No hidden fees. No surprises at the finish line. You always know exactly what you&apos;re paying for.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Quality Workmanship, Built to Last',
    description: 'Eleven years of Chicago builds — crafted with skill, care, and pride. We hold ourselves to the highest standards every single day.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Deep Local Expertise',
    description: 'We know Chicago&apos;s codes, climate, and communities better than anyone. That local knowledge keeps your project smooth and compliant.',
  },
  {
    icon: 'ri-star-smile-line',
    title: 'Your Satisfaction Is Our Standard',
    description: 'We don&apos;t close a job until you&apos;re completely happy with the results. Every detail matters, and your approval is the only metric that counts.',
  },
];

export default function WhyChooseSection() {
  return (
    <section id="why" className="py-24 md:py-32 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-start">
          {/* Left - Sticky Header + Image */}
          <div className="w-full lg:w-2/5 lg:sticky lg:top-28">
            <div className="text-red-600 text-sm font-semibold tracking-widest uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
              Why Butler Frelix
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 leading-tight mb-6" style={{ fontFamily: "'Oswald', sans-serif" }}>
              THE DIFFERENCE
              <br />
              <span className="text-red-700">IS IN THE</span>
              <br />
              LEGACY!
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
              One decision shapes everything that comes after. Here&apos;s why Chicago keeps choosing us.
            </p>
            <div className="rounded-xl overflow-hidden w-full h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/b90b8d8e0272b696fb4ef770a8b9f0a2.jpg"
                alt="Contractor and client shaking hands"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right - Reasons List */}
          <div className="w-full lg:w-3/5 flex flex-col gap-6">
            {REASONS.map((reason, i) => (
              <div
                key={reason.title}
                className="flex gap-5 bg-white border border-gray-100 rounded-xl p-6 hover:border-red-200 transition-colors"
              >
                <div className="flex-shrink-0 flex flex-col items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-xl">
                    <i className={`${reason.icon} text-red-700 text-xl`} />
                  </div>
                  <div className="text-blue-400 font-black text-xs" style={{ fontFamily: "'Oswald', sans-serif" }}>
                    0{i + 1}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-black text-gray-900 mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
                    {reason.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
